
import { defineComponent, SetupContext, ref, watch, toRefs, computed } from "vue";
import NativeClient from "@/client/native-client";
  
export default defineComponent({
  name: "CommonSwitch",
  props: {
    /** 初期値 */
    initialState: {
      type: Boolean,
      default: false
    },
    /** 操作禁止 */
    inhibit: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context: SetupContext) {
    const state = ref(props.initialState);

    // 状態変化の監視
    const { initialState } = toRefs(props);
    watch(initialState, () => {
      NativeClient.sendDebugLog("CommonSwitch watch");
      if (initialState.value != state.value) {
        NativeClient.sendDebugLog("CommonSwitch watch change state");
        state.value = initialState.value;
      }
    });

    const changeState = () => {
      NativeClient.sendDebugLog("CommonSwitch detect change state = " + state.value);
      context.emit("change-state", state.value);
    };

    return {
      state,
      changeState
    };
  }
});
